import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@percent/lemonade';
import { Card } from '@percent/hosted-validation-form/ui';
import { ReactComponent as CompleteIcon } from '@percent/hosted-validation-form/assets/icons/complete.svg';
import { usePartnerConfig } from '@percent/hosted-validation-form/hooks';

import styles from './Complete.module.scss';

export const Complete = () => {
  const { getValues } = useFormContext();
  const { partnerConfig } = usePartnerConfig();
  const { t } = useTranslation();

  const { avCheckAvailable, otpEnabled } = partnerConfig?.configuration ?? {};
  // With OTP the applicant has already verified their inbox during the flow, so pointing
  // them back at it would be confusing - drop the "check your inbox" sentence.
  const shouldMentionEmail = (avCheckAvailable === undefined || avCheckAvailable) && !otpEnabled;

  useEffect(() => {
    if (partnerConfig?.redirectUrl) {
      setTimeout(() => {
        window.location.href = partnerConfig.redirectUrl;
      }, 5000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card>
      <CompleteIcon className={styles.completeIcon} />
      <Typography variant="h2" className={styles.title}>
        {t('hostedValidation.complete.thanksForApplication')}
      </Typography>
      <Typography variant="large" className={styles.description}>
        {shouldMentionEmail
          ? t('hostedValidation.complete.partnerWithPercent', { percent: 'Goodstack', email: getValues('email') })
          : t('hostedValidation.complete.partneredWithPercent', { percent: 'Goodstack' })}
        <br />
        {t('hostedValidation.complete.willLetYouKnow')}
      </Typography>
    </Card>
  );
};
